module.exports = __webpack_public_path__ + "static/assets/e214dc66bba3d014deaa931a2be33f53.svg";